import { IconComponent } from '../icon/icon.component';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';

export interface SnackBarContentData {
	title?: string;
	body?: string;
	icon?: IconDefinition;
	action?: string;
	onAction?: () => void;
}

/** Snackbar content component. */
@Component({
	imports: [IconComponent, MatButtonModule],
	selector: 'g-snackbar-content',
	templateUrl: './snackbar-content.component.html',
	styleUrls: ['./snackbar-content.component.scss'],
})
export class SnackBarContentComponent {
	data = inject<SnackBarContentData>(MAT_SNACK_BAR_DATA);
}
